// SanMar product image helpers.
//
// Front: returns the item's colorImage as-is so EVERY item with
// any product photo can use the drag-and-drop placement editor.
// We only LABEL it "FRONT" when the URL actually says front
// (`_model_front`, `_flat_front`, `_bag_front`, `_full_front`) —
// for non-conventional URLs (`_bag_straight`, `_alt1`, `_pg270`)
// the card renders unlabeled, since "FRONT" would be misleading.
//
// Back: only returned when the front URL has a known pattern that
// has a reliable `_back` companion on SanMar's CDN.
//
// Mirrored on the backend at backend/lib/sanmarImages.js.

const FRONT_PATTERNS = [
  '_model_front',
  '_flat_front',
  '_bag_front',
  '_full_front',
];

export function getFrontUrl(item) {
  return item?.colorImage || null;
}

// Whether the front URL is conventionally labeled — used to decide
// whether to show a "FRONT" card label and whether a back URL is
// derivable.
export function isLabeledFront(url) {
  if (!url) return false;
  return FRONT_PATTERNS.some(p => url.includes(p));
}

export function getBackUrl(item) {
  const front = item?.colorImage;
  if (!front) return null;
  for (const needle of FRONT_PATTERNS) {
    if (front.includes(needle)) {
      return front.replace(needle, needle.replace('_front', '_back'));
    }
  }
  return null;
}
